<template>
  <div class="container">
    <o-bread-crumb>
      <template v-slot:pageName>
        API
      </template>
      <template v-slot:pageDetail>
        Log
      </template>
      <template v-slot:pageDescription>
        <br />
      </template>
    </o-bread-crumb>
    <div class="card text-center">
      <div class="card-header">
        <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
          <li class="nav-item">
            <div class="d-flex d-inline-block">
              <a class="nav-link text-dark fs-4" href="#">Logs of API</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading">
        </div>
        <div class="spinner" v-if="page.isLoading"></div>
        <div v-if="page.output">
          <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
            <li class="nav-item">
              <div class="d-flex d-inline-block">
                <o-search :searchOptions="searchOptions" :typeOptions="typeOptions" :methodOptions="methodOptions" :tenantOptions="tenantOptions" @submit="search" @clear="clearSearch"></o-search>
              </div>
            </li>
            <li class="nav-item btn btn-primary btn-sm">
              <button class="reload nav-link text-white" @click.prevent="load_state()">&#x21bb;</button>
            </li>
          </ul>
          <div class="table-responsive">
            <o-table class="table table-hover">
              <thead>
                <tr v-if="fields">
                  <th class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                    {{ field }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in apiLog" :key="index">
                  <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                  <td>{{ item.type }}</td>
                  <td>
                    <div>
                      <span v-if="urlIsExpanded[index]">{{ item.url }}</span>
                      <p v-else>...</p>
                      <button class="btn btn-link p-0 ms-2" @click="urlToggle(index)">
                        {{ urlIsExpanded[index] ? 'Collapse' : 'Expand' }}
                      </button>
                    </div>
                  </td>
                  <td>{{ item.method }}</td>
                  <td class="custom-json-pretty">
                    <vue-json-pretty :data="structuredDataRequest(item)" :deep="1" :theme="'dark'" :showIcon="true"></vue-json-pretty>
                  </td>
                  <td class="custom-json-pretty">
                    <vue-json-pretty :data="structuredDataResponse(item)" :deep="1" :theme="'dark'" :showIcon="true"></vue-json-pretty>
                  </td>
                  <td>{{ formatDate(item.created_at) }}</td>
                </tr>
              </tbody>
            </o-table>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <o-pagination :page="meta.page" :total="meta.total" @callback="navPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { OBreadCrumb, OTable, OSearch, OPagination } from '@/components/OmnihControl';
import { reactive, ref } from 'vue';
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

import { useApiLog } from '@/composables/useApiLog';
import { useJsonFormatter } from '@/composables/useJsonFormatter';
import { useUrlToggler } from '@/composables/useUrlToggler';

export default {
  setup() {
    const { page, meta, apiLog, tenantOptions, load_state, navPage, search, clearSearch } = useApiLog();
    const { structuredDataRequest, structuredDataResponse, formatDate } = useJsonFormatter();
    const { urlIsExpanded, urlToggle } = useUrlToggler();

    const fields = ref([
      'No',
      'Type',
      'URL',
      'Method',
      'Request Detail',
      'Response Detail',
      'Date'
    ]);

    const searchOptions = reactive([
      { value: 'tenant', text: 'tenant' },
      { value: 'type', text: 'type' },
      { value: 'method', text: 'method' },
    ]);

    const methodOptions = reactive([
      { value: 'GET', text: 'GET' },
      { value: 'POST', text: 'POST' },
      { value: 'PUT', text: 'PUT' },
      { value: 'DELETE', text: 'DELETE' }
    ]);

    const typeOptions = reactive([
      { value: 'in', text: 'in' },
      { value: 'out', text: 'out' },
    ]);

    return {
      page,
      meta,
      apiLog,
      fields,
      searchOptions,
      methodOptions,
      typeOptions,
      tenantOptions,
      load_state,
      navPage,
      search,
      clearSearch,
      structuredDataRequest,
      structuredDataResponse,
      formatDate,
      urlIsExpanded,
      urlToggle,
    };
  },
  components: {
    OTable,
    OPagination,
    OBreadCrumb,
    OSearch,
    VueJsonPretty
  }
};
</script>

<style scoped>
.container {
  overflow-x: auto;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  table-layout: fixed;
}

.table th,
.table td {
  word-wrap: break-word;
  white-space: normal;
}

.form-group {
  width: 250px;
  text-align: left;
  padding-left: 16px;
}

.custom-json-pretty {
  background-color: black;
  color: white; /* Custom font color */
  width: 35%;
  margin-bottom: 5px;
}

.custom-json-pretty .vue-json-pretty__key {
  color: #ffcc00; /* Custom key color */
}

.custom-json-pretty .vue-json-pretty__string {
  color: #56db3a; /* Custom string color */
}

.custom-json-pretty .vue-json-pretty__number {
  color: #00ccff; /* Custom number color */
}

.expanded-content {
  margin-top: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>